<!-- 嵌入式-维修办结 -->
<template>
  <el-card>
    <div class="toolbar">
      <el-button type="primary" @click="onRecordClick()">
        <i class="fa fa-print"></i> 维修统计
      </el-button>
      <el-button type="primary" @click="onRateClick()">
        <i class="fa fa-print"></i> 故障率统计
      </el-button>
      <div class="former">
        <el-input
          v-model.trim="key"
          placeholder="名称、SN或送修来源"
          @keydown.enter.native="onSubmitQuery"
        >
        </el-input
        >&nbsp;
        <el-select v-model="former.Type" clearable placeholder="维修类型">
          <el-option label="产品" :value="0"></el-option>
          <el-option label="配件" :value="1"></el-option> </el-select
        >&nbsp;
        <select2
          labelName="Name"
          v-model="former.DealPeopleID"
          url="user"
          clearable
          placeholder="处理人"
          no-data-text="没有处理人"
        ></select2
        >&nbsp;
        <select2
          labelName="Value"
          valueKey="Key"
          v-model="former.DealStatus"
          url="dci/maintain/status-list"
          clearable
          placeholder="维修状态"
          no-data-text="没有维修状态"
          :currentList="curStatus"
        ></select2
        >&nbsp;
        <el-button type="primary" @click="onSubmitQuery">
          <i class="fas fa-search"></i>
        </el-button>
      </div>
    </div>
    <el-table :data="itemList" v-loading="loading" size="medium">
      <el-table-column
        type="index"
        :index="pager.size * (pager.page - 1) + 1"
        :width="Math.max(40, (pager.size * pager.page).toString().length * 12)"
      />
      <el-table-column label="类型" width="70">
        <template slot-scope="scope">
          <el-tag v-if="scope.row.Type === 0" type="warning"> 产品 </el-tag>
          <el-tag v-if="scope.row.Type === 1" type="success"> 配件 </el-tag>
        </template>
      </el-table-column>
      <el-table-column label="产品/配件型号名称" width="200">
        <template slot-scope="scope">
          <div v-if="scope.row.DciProduct !== null">
            {{ scope.row.DciProduct.DciProductModel.NameNumber }}
          </div>
          <div v-if="scope.row.DciAccessory !== null">
            {{ scope.row.DciAccessory.DciAccessoryModel.NameNumber }}
          </div>
        </template>
      </el-table-column>
      <el-table-column label="产品/配件SN" width="190">
        <template slot-scope="scope">
          <el-tag v-if="scope.row.DciProduct !== null">
            {{ scope.row.DciProduct.SN }}
          </el-tag>
          <el-tag
            type="success"
            v-if="
              scope.row.DciProduct !== null &&
              scope.row.DciProduct.Remark !== ''
            "
          >
            {{ scope.row.DciProduct.Remark }}
          </el-tag>
          <el-tag v-if="scope.row.DciAccessory !== null">
            {{ scope.row.DciAccessory.SN }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column label="送修来源">
        <template slot-scope="scope">
          {{ scope.row.SendSource }}
          <el-tooltip
            content="Top center"
            placement="top"
            effect="light"
            v-if="scope.row.AmbSaleOrderCode !== ''"
          >
            <div slot="content">报价单：{{scope.row.AmbSaleOrderCode}}</div>
            <i
              class="fas fa-file"
              style="color: #67c23a; cursor: pointer"
              @click="onShowSaleOrder(scope.row)"
            ></i>
          </el-tooltip>
        </template>
      </el-table-column>
      <el-table-column label="送修日期" width="100">
        <template slot-scope="scope">
          <div v-if="scope.row.SendAt">
            {{ $sys.dateFormat(scope.row.SendAt, "Y-m-d") }}
          </div>
        </template>
      </el-table-column>
      <el-table-column width="140">
        <template slot="header" slot-scope="scope">
          <div
            style="padding-left: 0px; padding-right: 0px; line-height: normal"
          >
            期望初检完成日期
          </div>
          <div
            style="
              padding-left: 0px;
              padding-right: 0px;
              line-height: normal;
              margin-top: -5px;
            "
          >
            期望维修完成日期
          </div>
        </template>
        <template slot-scope="scope">
          <div
            v-if="
              scope.row.ExpectedInspectAt &&
              new Date(scope.row.ExpectedInspectAt).getTime() <=
                new Date(new Date()).getTime() &&
              (scope.row.DealStatus === 0 ||
                scope.row.DealStatus === 1 ||
                scope.row.DealStatus === 2)
            "
            style="color: red"
          >
            {{ $sys.dateFormat(scope.row.ExpectedInspectAt, "Y-m-d H:i") }}
          </div>
          <div v-else-if="scope.row.ExpectedInspectAt">
            {{ $sys.dateFormat(scope.row.ExpectedInspectAt, "Y-m-d H:i") }}
          </div>
          <div
            v-if="
              scope.row.ExpectedDealAt &&
              new Date(scope.row.ExpectedDealAt).getTime() <=
                new Date(new Date()).getTime() &&
              scope.row.DealStatus !== 6
            "
            style="color: red"
          >
            {{ $sys.dateFormat(scope.row.ExpectedDealAt, "Y-m-d H:i") }}
          </div>
          <div v-else-if="scope.row.ExpectedDealAt">
            {{ $sys.dateFormat(scope.row.ExpectedDealAt, "Y-m-d H:i") }}
          </div>
        </template>
      </el-table-column>
      <el-table-column label="更换方式" width="90">
        <template slot-scope="scope">
          <el-tag v-if="scope.row.ReplacementMode === 0" type="warning">
            不更换
          </el-tag>
          <el-tag v-if="scope.row.ReplacementMode === 1" type="primary">
            更换配件
          </el-tag>
          <el-tag v-if="scope.row.ReplacementMode === 2" type="info">
            更换整机
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="DealPeople.Name" label="处理人" width="70" />
      <el-table-column prop="DealStatusName" label="维修状态" width="105">
        <template slot-scope="scope">
          <el-tag v-if="scope.row.DealStatus === 5" type="warning">
            {{ scope.row.DealStatusName }}
          </el-tag>
          <el-tag v-else type="success">
            {{ scope.row.DealStatusName }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column width="140" label="操作">
        <template slot-scope="scope">
          <el-button
            type="button"
            @click.stop="onDetailItem(scope.row)"
            title="详情"
          >
            <i class="fas fa-eye"></i>
          </el-button>
          <el-button
            type="primary"
            @click.stop="onPrintItem(scope.row)"
            title="打印"
          >
            <i class="fa fa-print"></i>
          </el-button>
          <el-button
            type="success"
            @click.stop="onFinishClick(scope.row)"
            title="维修办结"
            v-if="scope.row.DealStatus === 5"
            v-permission="'dci_maintain_finish-POST'"
          >
            <i class="fas fa-tasks"></i>
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <div class="clearfix mar-top-10">
      <el-pagination
        class="pull-right"
        @current-change="onChangePage"
        layout="total, prev, pager, next"
        :total="pager.total"
        :current-page="pager.page"
        :page-size="pager.size"
      >
      </el-pagination>
    </div>

    <detail-form v-model="item" :visible.sync="deltailVisible" />

    <finish-form
      v-model="finishItem"
      :visible.sync="finishVisible"
      @form:saved="getItemList"
    />

    <el-dialog
      title="维修统计"
      :visible.sync="statisticsVisible"
      append-to-body
      :close-on-click-modal="false"
      @close="onClose()"
      width="20%"
    >
      <el-form
        ref="statisticsItemForm"
        label-width="120px"
        :model="statisticsItem"
        :rules="statisticsRules"
      >
        <el-form-item label="开始日期" prop="fromAt">
          <el-date-picker
            v-model="statisticsItem.fromAt"
            style="width: 100%"
            type="date"
            placeholder="请选择日期"
            value-format="yyyy-MM-dd"
            format="yyyy-MM-dd"
          ></el-date-picker>
        </el-form-item>
        <el-form-item label="结束日期" prop="fromAt">
          <el-date-picker
            v-model="statisticsItem.toAt"
            style="width: 100%"
            type="date"
            placeholder="请选择日期"
            value-format="yyyy-MM-dd"
            format="yyyy-MM-dd"
          ></el-date-picker>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="onClose()">
          <i class="fas fa-fw fa-times" aria-hidden="true"></i> 取 消
        </el-button>
        <el-button type="primary" @click="onStatistics" :disabled="submitting">
          <i class="far fa-fw fa-save" aria-hidden="true"></i> 确 定
        </el-button>
      </div>
    </el-dialog>

    <el-dialog
      title="故障率统计"
      :visible.sync="rateVisible"
      append-to-body
      :close-on-click-modal="false"
      @close="onRateClose()"
      width="20%"
    >
      <el-form
        ref="rateItemForm"
        label-width="80px"
        :model="rateItem"
        :rules="rateRules"
      >
        <el-form-item label="产品型号" prop="model">
          <el-select
            v-model="rateItem.model"
            :clearable="false"
            placeholder="选择产品型号"
            style="width: 100%"
          >
            <el-option
              v-for="ele in modelList"
              :key="ele"
              :label="ele"
              :value="ele"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="批次" prop="batch">
          <el-select
            v-model="rateItem.batch"
            :clearable="false"
            placeholder="选择批次"
            :disabled="!rateItem.model"
            style="width: 100%"
          >
            <el-option
              v-for="ele in batchList"
              :key="ele"
              :label="ele"
              :value="ele"
            >
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="onRateClose()">
          <i class="fas fa-fw fa-times" aria-hidden="true"></i> 取 消
        </el-button>
        <el-button type="primary" @click="onBatch" :disabled="submitting">
          <i class="far fa-fw fa-save" aria-hidden="true"></i> 确 定
        </el-button>
      </div>
    </el-dialog>
  </el-card>
</template>

<script>
import DetailForm from "../maintainRegister/detail.vue"; //使用维修登记中的维修详情，公用
import FinishForm from "./finishForm.vue"; //维修办结

export default {
  components: {
    DetailForm,
    FinishForm,
  },
  data() {
    return {
      itemList: [],
      loading: false,
      pager: {
        total: 0,
        page: 1,
        size: 15,
      },
      former: {
        Type: "",
        DealPeopleID: "",
        DealStatus: "",
      },
      key: "",
      item: this.getEmptyItem(),
      finishItem: this.getEmptyFinishItem(),
      deltailVisible: false, //查看详情
      finishVisible: false, //维修办结
      curStatus: [],
      // ===========维修统计===========
      statisticsVisible: false,
      submitting: false,
      statisticsItem: {
        fromAt: "",
        toAt: "",
      },
      statisticsRules: {
        fromAt: [
          { required: true, message: "开始日期不能为空", trigger: "blur" },
        ],
        toAt: [
          { required: true, message: "结束日期不能为空", trigger: "blur" },
        ],
      },
      // ==============================

      // ===========故障率统计===========
      modelList: [], //产品名称
      batchList: [], //批次
      rateVisible: false,
      rateItem: {
        model: "", //大型号
        batch: "", //批次
      },
      rateRules: {
        model: [
          { required: true, message: "产品型号不能为空", trigger: "blur" },
        ],
        batch: [{ required: true, message: "批次不能为空", trigger: "blur" }],
      },
      // ==============================
    };
  },
  watch: {
    "rateItem.model": {
      handler() {
        if (this.rateItem.model) {
          this.$axios
            .post(`dci/product/stock-list/batch/list`, {
              model: this.rateItem.model,
            })
            .then((response) => {
              this.batchList = response.data;
            })
            .catch(({ response }) => {
              this.$sys.alarmResponse(response);
            });
        }
      },
    },
  },
  mounted() {
    this.getItemList();
    this.getModelList();
  },
  created() {
    this.curStatus = [
      {
        Key: 5,
        Value: "办结中",
      },
    ];
  },
  methods: {
    getItemList() {
      this.loading = true;
      this.$axios
        .get("dci/maintain/finish", {
          params: {
            where: this.former,
            with: [
              "DciProduct.DciProductModel",
              "DciAccessory.DciAccessoryModel",
              "MaintainUser",
              "SendPeople",
              "DealPeople",
              // "DciSaleOrder",
            ],
            ...this.pager,
            key: this.key,
            order: ["deal_status", "-send_at"],
          },
        })
        .then((response) => {
          this.itemList = response.data.data;
          this.pager = _.pick(response.data, "size", "page", "total");
        })
        .catch(({ response }) => {
          this.$sys.alarmResponse(response);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    //维修详情
    onDetailItem(row) {
      this.item = row;
      this.deltailVisible = true;
    },
    getEmptyItem() {
      return {};
    },
    getEmptyFinishItem() {
      return {
        ID: "", //维修id
        FinishDesc: "", //办结说明
        ExpressNumber: "", //快递单号
        SendingAt: new Date(), //寄出日期
        Addressee: "", //收件人
        ExpressDesc: "", //快递说明
      };
    },
    onSubmitQuery() {
      this.pager.page = 1;
      this.getItemList();
    },
    onChangePage(page) {
      this.pager.page = page;
      this.getItemList();
    },

    //维修办结
    onFinishClick(row) {
      this.finishItem = this.getEmptyFinishItem();
      this.finishItem.ID = row.ID;
      this.finishVisible = true;
    },

    //打印维修处理单
    onPrintItem(row) {
      this.$axios
        .get(`dci/maintain/print/${row.ID}`, {
          responseType: "blob", //服务器响应的数据类型，可以是 'arraybuffer', 'blob', 'document', 'json', 'text', 'stream'，默认是'json'
        })
        .then((res) => {
          if (!res) {
            return;
          }
          const blob = new Blob([res.data], {
            type: "application/vnd.ms-excel",
          }); // 构造一个blob对象来处理数据，并设置文件类型

          let fName = "维修处理单";
          if (row.DciProduct !== null) {
            fName += "(" + row.DciProduct.SN + ")";
          } else if (row.DciAccessory !== null) {
            fName += "(" + row.DciAccessory.SN + ")";
          }
          fName += ".xlsx";

          if (window.navigator.msSaveOrOpenBlob) {
            //兼容IE10
            navigator.msSaveBlob(blob, fName);
          } else {
            const href = URL.createObjectURL(blob); //创建新的URL表示指定的blob对象
            const a = document.createElement("a"); //创建a标签
            a.style.display = "none";
            a.href = href; // 指定下载链接
            a.download = fName; //指定下载文件名
            a.click(); //触发下载
            URL.revokeObjectURL(a.href); //释放URL对象
          }
          // 这里也可以不创建a链接，直接window.open(href)也能下载
        })
        .catch((err) => {
          console.log(err);
        });
    },
    onShowSaleOrder(row){
        window.open(row.AmbSaleOrderUrl, "_blank");
    },
    // //打印维修报价单【暂不启用】
    // onPrintSaleOrder(row) {
    //   this.$axios
    //     .get(`dci/maintain/sale/print/${row.DciSaleOrderID}`, {
    //       responseType: "blob", //服务器响应的数据类型，可以是 'arraybuffer', 'blob', 'document', 'json', 'text', 'stream'，默认是'json'
    //     })
    //     .then((res) => {
    //       if (!res) {
    //         return;
    //       }
    //       const blob = new Blob([res.data], {
    //         type: "application/vnd.ms-excel",
    //       }); // 构造一个blob对象来处理数据，并设置文件类型

    //       let fName = "维修报价单";
    //       if (row.DciSaleOrder.Code !== "") {
    //         fName += "(" + row.DciSaleOrder.Code + ")";
    //       }
    //       fName += ".xlsx";

    //       if (window.navigator.msSaveOrOpenBlob) {
    //         //兼容IE10
    //         navigator.msSaveBlob(blob, fName);
    //       } else {
    //         const href = URL.createObjectURL(blob); //创建新的URL表示指定的blob对象
    //         const a = document.createElement("a"); //创建a标签
    //         a.style.display = "none";
    //         a.href = href; // 指定下载链接
    //         a.download = fName; //指定下载文件名
    //         a.click(); //触发下载
    //         URL.revokeObjectURL(a.href); //释放URL对象
    //       }
    //       // 这里也可以不创建a链接，直接window.open(href)也能下载
    //     })
    //     .catch((err) => {
    //       console.log(err);
    //     });
    // },
    //===============维修统计===================
    //点击维修统计按钮
    onRecordClick() {
      var now = new Date();
      var year = now.getFullYear(); //得到年份
      this.statisticsItem.fromAt = `${year}-01-01`;
      this.statisticsItem.toAt = `${year}-12-31`;
      this.statisticsVisible = true;
    },
    //统计数据
    onStatistics() {
      this.$refs.statisticsItemForm.validate((valid) => {
        if (!valid) {
          return;
        }
        this.submitting = true;
        this.$emit("input", this.statisticsItem);
        const itemData = { ...this.statisticsItem };
        this.$axios
          .post(`dci/maintain/print/statistics`, itemData, {
            responseType: "blob", //服务器响应的数据类型，可以是 'arraybuffer', 'blob', 'document', 'json', 'text', 'stream'，默认是'json'
          })
          .then((res) => {
            if (!res) {
              return;
            }
            const blob = new Blob([res.data], {
              type: "application/vnd.ms-excel",
            }); // 构造一个blob对象来处理数据，并设置文件类型

            let fName =
              "维修记录表(" +
              this.statisticsItem.fromAt +
              "~" +
              this.statisticsItem.toAt +
              ").xlsx";

            if (window.navigator.msSaveOrOpenBlob) {
              //兼容IE10
              navigator.msSaveBlob(blob, fName);
            } else {
              const href = URL.createObjectURL(blob); //创建新的URL表示指定的blob对象
              const a = document.createElement("a"); //创建a标签
              a.style.display = "none";
              a.href = href; // 指定下载链接
              a.download = fName; //指定下载文件名
              a.click(); //触发下载
              URL.revokeObjectURL(a.href); //释放URL对象

              this.submitting = false;
              this.onClose();
            }
            // 这里也可以不创建a链接，直接window.open(href)也能下载
          })
          .catch((err) => {
            this.submitting = false;
            this.onClose();
            console.log(err);
          });
      });
    },
    onClose() {
      this.$refs.statisticsItemForm.resetFields();
      this.statisticsVisible = false;
    },
    //==========================================

    //===============故障率统计===================
    //获取产品型号名称列表
    getModelList() {
      this.$axios.get("dci/model/product/name/list").then(
        (response) => {
          this.modelList = response.data;
        },
        (response) => {
          this.$sys.alarmResponse(response);
        }
      );
    },
    //点击故障率统计按钮
    onRateClick() {
      this.rateItem.model = "";
      this.rateItem.batch = "";
      this.rateVisible = true;
    },
    //故障率统计
    onBatch() {
      this.$refs.rateItemForm.validate((valid) => {
        if (!valid) {
          return;
        }
        this.submitting = true;
        this.$emit("input", this.rateItem);
        const itemData = { ...this.rateItem };
        this.$axios
          .post(`dci/maintain/print/batch`, itemData, {
            responseType: "blob", //服务器响应的数据类型，可以是 'arraybuffer', 'blob', 'document', 'json', 'text', 'stream'，默认是'json'
          })
          .then((res) => {
            if (!res) {
              return;
            }
            const blob = new Blob([res.data], {
              type: "application/vnd.ms-excel",
            }); // 构造一个blob对象来处理数据，并设置文件类型

            let fName =
              "故障率记录表(" +
              this.rateItem.model +
              "-" +
              this.rateItem.batch +
              ").xlsx";

            if (window.navigator.msSaveOrOpenBlob) {
              //兼容IE10
              navigator.msSaveBlob(blob, fName);
            } else {
              const href = URL.createObjectURL(blob); //创建新的URL表示指定的blob对象
              const a = document.createElement("a"); //创建a标签
              a.style.display = "none";
              a.href = href; // 指定下载链接
              a.download = fName; //指定下载文件名
              a.click(); //触发下载
              URL.revokeObjectURL(a.href); //释放URL对象

              this.submitting = false;
              this.onRateClose();
            }
            // 这里也可以不创建a链接，直接window.open(href)也能下载
          })
          .catch((err) => {
            this.submitting = false;
            this.onRateClose();
            console.log(err);
          });
      });
    },
    onRateClose() {
      this.$refs.rateItemForm.resetFields();
      this.rateVisible = false;
    },
    //==========================================
  },
};
</script>

